import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { css, styled } from 'styled-components';
import THEME from '../theme.js';
import ArrowDown from './Icons/ArrowDown.js';
import PlaceholderLoader from './PlaceholderLoader.js';
const Button = (props) => {
    const theme = useSelector(() => THEME);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const baseProps = {
        className: `btn ${props.className} ${props.theme} ${props.size} ${props.block ? 'block' : ''} ${props.blockOnMobile ? 'block-on-mobile' : ''} ${props.loading ? 'loading' : ''} ${(props.disabled || props.loading) && 'disabled'} ${props.dropdown ? `dropdown ${dropdownOpen ? 'dropdown-open' : ''}` : ''}`,
        ref: props.ref || props.innerRef,
        style: props.style,
        tabIndex: props.tabIndex,
    };
    const loaderStyles = {
        position: 'absolute',
        top: '0px',
        left: '0px',
        height: '100%',
        opacity: props.loading ? 0.85 : 0,
        transition: 'opacity .3s',
    };
    return props.href ? (React.createElement(StyledLink, { style: { textDecoration: 'none' }, download: !!props.download, href: props.href, id: props.id, target: props.target, className: props.block ? 'block' : '', "data-tooltip-id": props.tooltip ? 'tooltip-default' : undefined, "data-tooltip-content": props.tooltip },
        React.createElement(StyledA, { onClick: (e) => {
                if (props.disabled) {
                    e.preventDefault();
                }
                else {
                    props.onClick && props.onClick(e);
                }
            }, theme: theme, onMouseEnter: props.onMouseEnter, ...baseProps },
            React.createElement(PlaceholderLoader, { style: loaderStyles }),
            props.children || props.value))) : (React.createElement(StyledButton, { onClick: (e) => {
            props.onClick && props.onClick(e);
            props.dropdown && setDropdownOpen(!dropdownOpen);
        }, disabled: props.disabled || props.loading, id: props.id, theme: theme, onMouseEnter: props.onMouseEnter, "data-tooltip-id": props.tooltip ? 'tooltip-default' : undefined, "data-tooltip-content": props.tooltip, ...baseProps },
        React.createElement(PlaceholderLoader, { style: loaderStyles }),
        props.children || props.value,
        !props.children && !props.value && props.dropdown && React.createElement(ArrowDown, null),
        props.dropdown && dropdownOpen && (React.createElement(DropdownMenu, { className: "dropdown-menu" }, props.dropdown.map((dd) => (React.createElement(Dropdown, { disabled: dd.disabled, onClick: dd.onClick, className: `btn ${dd.className || ''} ${dd.theme || ''}`, theme: theme }, dd.value)))))));
};
export default Button;
const styles = (theme) => css `
  transition: background-color 200ms ease-in-out;
  background-color: ${theme.COLOR_ACCENT};
  padding: 13px;
  font-size: 0.7em;
  outline: none;
  border-radius: 3px;
  border: none;
  color: #fff;
  text-transform: uppercase;
  display: inline-block;
  font-weight: 900;
  opacity: 1;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);

  &.dropdown {
    overflow: initial;

    &.dropdown-open {
      border-bottom-left-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }
  }

  &:disabled,
  &.disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &.loading {
    cursor: progress;
  }

  &.light {
    color: ${theme.COLOR_PRIMARY};
    background-color: ${theme.COLOR_SECONDARY};
  }

  &.dangerous {
    color: ${theme.COLOR_SECONDARY};
    background-color: ${theme.DANGEROUS};
  }

  &.success {
    color: ${theme.COLOR_SECONDARY};
    background-color: ${theme.SUCCESS};
  }

  &.secondary {
    color: ${theme.COLOR_PRIMARY};
    background-color: lightgrey;
  }

  &.transparent {
    color: inherit;
    background-color: none !important;
  }

  &.warning {
    color: ${theme.COLOR_SECONDARY};
    background-color: ${theme.WARNING};
  }

  &.text {
    color: ${theme.COLOR_PRIMARY};
    background: none;
    padding: 0;
    box-shadow: none;
  }

  &.link {
    color: ${theme.COLOR_ACCENT};
    background: none;
    padding: 0;
    box-shadow: none;
    font-size: 0.9em;
    font-weight: bold;
    text-transform: none;

    &:focus:after {
      content: none;
    }

    &:focus-visible {
      text-decoration: underline;
    }
  }

  &.block {
    display: block;
    width: 100%;
  }

  @media ${theme.MEDIA_QUERY_MOBILE} {
    &.block-on-mobile {
      display: block;
      width: 100%;
    }
  }

  &.small {
    padding: 10px 15px;
  }

  &.mini {
    padding: 6px 12px;
    font-size: 0.6em;
  }

  &:active {
    box-shadow: inset 0px 0px 5px #9a9898;

    &:disabled,
    &.disabled {
      opacity: 0.6;
    }
  }

  &:focus:after {
    content: ' ';
    position: absolute;
    bottom: 3px;
    width: calc(100% - 14px);
    border-radius: 3px;
    height: 3px;
    left: 7px;
    background-color: ${theme.COLOR_SECONDARY};
  }

  &.light:focus:after,
  &.secondary:focus:after {
    background-color: ${theme.COLOR_ACCENT};
  }
`;
const StyledButton = styled.button `
  ${(props) => styles(props.theme)};
`;
const StyledLink = styled.a `
  &.block {
    display: block;
    width: 100%;
  }
`;
const StyledA = styled.div `
  ${(props) => styles(props.theme)};
  text-align: center;
`;
const DropdownMenu = styled.div `
  position: absolute;
  left: 0;
  top: 100%;
  width: 150px;
  z-index: 9999999;
  overflow: hidden;
  border-radius: 3px;
  border-top-left-radius: 0;
`;
const Dropdown = styled.button `
  ${(props) => styles(props.theme)};
  border-radius: 0;
  display: block;
  width: 100%;
  text-align: left;
  box-shadow: inset 0px -1px 0px 0px rgba(0, 0, 0, 0.5);

  &:last-child {
    box-shadow: none;
  }
`;
//# sourceMappingURL=Button.js.map